import Demetra from '@adoratorio/demetra';

export default new Demetra({
  endpoint: 'https://moonshot.adorator.io/api.php',
  lang: 'en',
  cache: false,
});
